import { useContext, useEffect, useState } from 'react';

import { AppContext } from 'commons-ui';
import useService from '../useService';

const useBankDetails = () => {
	const [forceUpdate, setForceUpdate] = useState<boolean>(false);
	const [dataListKey, setDataListKey] = useState<number>(0);
	const [bankDetailsIsCollapsed, setBankDetailsIsCollapsed] = useState<boolean>(true);
	const [dataFetchComplete, setDataFetchComplete] = useState<boolean>(false);
	const [bankDetails, setBankDetails] = useState<any>([]);
	const [showLoader, setShowLoader] = useState<boolean>(false);
	const { showAlert } = useContext(AppContext);
	const { getBankOrVpaDetails } = useService();

	const fetchRowData = async () => {
		try {
			setShowLoader(true);
			const fetchedData = await getBankOrVpaDetails(false, true);
			setBankDetails({ rowCount: fetchedData.rowCount, data: fetchedData.data });
		} catch (error: any) {
			showAlert('Error while fetching data.', { type: 'error' });
		} finally {
			setShowLoader(false);
			setDataFetchComplete(true);
		}
	};

	useEffect(() => {
		if (!bankDetailsIsCollapsed && !dataFetchComplete) {
			fetchRowData();
		}
	}, [bankDetailsIsCollapsed]);

	const handleDatalistFetchData = () => {
		return bankDetails;
	};

	const turnForceUpdateOff = () => {
		setForceUpdate(false);
	};

	const updateDetails = (listData: any[]) => {
		setBankDetails({ rowCount: listData.length, data: listData });
		setDataFetchComplete(true);
		setDataListKey((prev) => prev + 1);
	};

	return {
		bankDetailsIsCollapsed,
		setBankDetailsIsCollapsed,
		showLoader,
		handleDatalistFetchData,
		turnForceUpdateOff,
		forceUpdate,
		dataFetchComplete,
		updateDetails,
		dataListKey
	};
};

export default useBankDetails;
